'use strict';
/**
 * Message piggybacking another message that has been forwarded by an
 * intermediate peer.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var MForwarded =
/**
   * @param {string} from The departure of the piggybacked message.
   * @param {string} to The arrival of the piggybacked message.
   * @param {object} message The piggybacked message to deliver.
   */
function MForwarded(from, to, message) {
  _classCallCheck(this, MForwarded);

  this.from = from;
  this.to = to;
  this.message = message;
  this.type = 'MForwarded';
};

;
module.exports = MForwarded;